import type { EditorHost } from '@blocksuite/std';

export function isInsidePageEditor(host: EditorHost) {
  return Array.from(host.children).some(
    v => v.tagName.toLowerCase() === 'hive-page-root'
  );
}

export function isInsideEdgelessEditor(host: EditorHost) {
  if (!host) return false;

  return Array.from(host.children).some(
    v =>
      v.tagName.toLowerCase() === 'hive-edgeless-root' ||
      v.tagName.toLowerCase() === 'hive-edgeless-root-preview'
  );
}
